import Immutable from "immutable";
import React from "react";
import {
	AIRPORTS_URL,
	OPERATORS_URL,
	renderAirportCodeLink,
	renderCountryLink,
	renderLink,
	renderSubdivisionLink,
} from "../search/result/renderers";
import useResultTableLayout from "../search/result/useResultTableLayout";

export function renderOriginAndDestination(value) {
	const airportCode = value.getIn(["airport", "code"]);
	const resultBy = useResultTableLayout();

	if (resultBy === "data") {
		return renderLink(
			AIRPORTS_URL + airportCode,
			value.getIn(["airport", "name"]),
		);
	}

	const airportLink = renderLink(AIRPORTS_URL + airportCode, airportCode);
	const countryLink = renderCountryLink(value.get("country"));

	return (
		<>
			{value.getIn(["airport", "name"])} ({airportLink}), {countryLink}
		</>
	);
}

export function renderAirlineLink(value) {
	if (!value.get("code")) {
		return null;
	}
	const resultBy = useResultTableLayout();

	return (
		value &&
		renderLink(
			OPERATORS_URL + value.get("code"),
			value.get("name"),
			resultBy === "data" ? "" : value.get("iata"),
		)
	);
}

function renderAirlineDetailsLink(value) {
	return renderLink(OPERATORS_URL + value.get("code"), "Details");
}

// FIXME: Can be replaced by default origin renderer after CHA-7577
export function renderOriginTitle(section) {
	const departure = section.getIn(["origin", "airport"]);
	const name = departure.get("name");
	const country = section.getIn(["origin", "country"]);
	const subdivision = section.getIn(["origin", "subdivision"]);
	const subdivisionLink = subdivision && renderSubdivisionLink(subdivision);
	return (
		<p className="h3">
			<span>Origin:</span> {name} ({renderAirportCodeLink(departure)}),{" "}
			{subdivisionLink}
			{subdivisionLink && ", "} {renderCountryLink(country)}
		</p>
	);
}

export function renderAirlineTitle(section) {
	const airline = section.get("airline", Immutable.Map());
	const name = airline.get("name");
	const base = airline.get("base");
	const baseName = base.get("name");
	const iata = airline.get("iata");
	const icao = airline.get("icao");
	const details = renderAirlineDetailsLink(airline);

	return (
		<>
			<p className="title">{name}</p>
			<p className="subtitle">
				Base: {baseName} ({renderAirportCodeLink(base)}) | IATA: {iata}{" "}
				| ICAO: {icao} | {details}
			</p>
		</>
	);
}
